import React from 'react';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    maxWidth: '90vw',
  },
}));

export const DialogBox = ({ open, onClose, children, sx, ...props }) => {
  return (
    <StyledDialog open={Boolean(open)} onClose={onClose} sx={sx} {...props}>
      {children}
    </StyledDialog>
  );
};

export default DialogBox;
